module.exports = __webpack_public_path__ + "img/India 2.b43caad7.jpeg";